import React, { useContext, useEffect } from "react";
import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Skeleton,
  Icon,
  Box,
} from "@chakra-ui/react";
import { useHistory, useParams } from "react-router-dom";
import { BiDetail } from "react-icons/bi";
import { UsersContext } from "../../Context/UsersContext";
import ResponsiveRow from "../../Common/Table/ResponsiveRow";
import TdType from "../../Common/Table/TdType";

function OperatorsTable() {
  const { users, getUsers, isLoadingUser } = useContext(UsersContext);
  const history = useHistory();

  useEffect(() => {
    getUsers({ roleId: 2 });
  }, []);

  let params = useParams().state;

  const handleActiveSwitch = (user, value) => {
    let newUsers = [...users];

    let index = newUsers.findIndex((newProduct) => user.id === newProduct.id);
    newUsers[index].active = value;
  };

  const setDataTable = (user) => {
    return [
      {
        item: <TdType text={user.businessName} />,
      },
      {
        item: <TdType text={user.address} />,
      },
      {
        item: <TdType text={user.email} />,
      },
      {
        item: (
          <TdType
            inputType={"switch"}
            isChecked={user.active}
            onChange={(e) => handleActiveSwitch(user, e.target.checked)}
          />
        ),
      },
      {
        tdStyle: { textAlign: "center" },
        item: (
          <Icon
            as={BiDetail}
            _hover={{
              cursor: "pointer",
            }}
            title="Detalle"
            fontSize="1.5em"
            onClick={() =>
              history.push(`/usuarios/${user.id}`, {
                prevPath: params,
              })
            }
          ></Icon>
        ),
      },
    ];
  };
  return (
    <Box overflowX={"scroll"} pb={"0.5rem"}>
      <Table variant="striped" colorScheme="gray" fontSize="0.8em" w="100%">
        <Thead>
          <Tr>
            <Th fontSize="0.8em">Razon Social</Th>
            <Th fontSize="0.8em">Domicilio</Th>
            <Th fontSize="0.8em">Email</Th>
            <Th fontSize="0.8em" textAlign="center">
              Activo
            </Th>
            <Th fontSize="0.8em" textAlign="center">
              Detalle
            </Th>
          </Tr>
        </Thead>

        <Tbody>
          {isLoadingUser ? (
            <Tr>
              <Td colSpan="100%">
                <Skeleton h="1rem" />
              </Td>
            </Tr>
          ) : (
            users.map((user) => (
              <ResponsiveRow
                key={user.id}
                cells={setDataTable(user)}
                hover={{
                  outline: "2px  #3498DB solid",
                }}
              />
            ))
          )}
        </Tbody>
      </Table>
    </Box>
  );
}

export default OperatorsTable;
